import { authHeader } from '../_core/auth-header';
import Config from '../_core/config';

// import OAuth from 'oauth-1.0a';
// import crypto from 'crypto';

export const paymentService = {
    payment,
    process,
    getPostType,
    paynamics
};

// Update the JavaScript function to handle Paynamics payment
function paynamics(orderId) {
    const apiUrl = '/wp-json/paynamics/v1/process_payment';

    return new Promise((resolve, reject) => {
        fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ order_id: orderId }),
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.text();
        })
        .then(text => {

            const data = JSON.parse(text);

            if (data.redirect_url) {
                window.location.replace(data.redirect_url);
            } else if(data.url && data.form && data.form.paymentrequest) {
                // Create a form dynamically
                const form = document.createElement('form');
                form.method = data.method;
                form.action = data.url;
                
                // Add hidden input for payment request
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = 'paymentrequest';
                input.value = data.form.paymentrequest;
                form.appendChild(input);
                
                // Append the form to the body
                document.body.appendChild(form);

                // Redirect to successful payment page after a delay
                setTimeout(() => {
                    form.submit();
                }, 3000); // Adjust the delay time as needed
            } else {
                throw new Error('Failed to get Paynamics redirect URL or payment initiation failed');
            }
        })
        .catch(error => {
            console.error('Error initiating Paynamics payment:', error);
            reject(error);
        });
    });
}






function payment(body) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(body)
    };
    
    return fetch(Config.api.basepath+`/payment`, requestOptions).then(handleResponse).then(res=>process(res))
}

function process(id) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(id)
    };
    
    return fetch(Config.api.basepath+`/process`, requestOptions).then(handleResponse)  
}


function getPostType(type) {
    return fetch(`/wp-json/wp/v2/${type}`)
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to fetch image URL');
            }
            return response.json();
        })
        .then(data => data.source_url)
        .catch(error => {
            console.error('Error fetching image URL:', error);
            return null;
        });
}



// function oauthFunction() {
    
//     const oauth = OAuth({
//         consumer: {
//             key: Config.woocommerce.key,
//             secret: Config.woocommerce.secret
//         },
//         signature_method: 'HMAC-SHA1',
//         hash_function(baseString, key) {
//             return crypto.createHmac('sha1', key).update(baseString).digest('base64');
//         }
//     });


//     return oauth
// }

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data.error) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}